import { TicketRequiredRowFragmentDoc } from '../../graphql/hasura/generated';

import model from './model';

model.setFormOptions({
  fields: [],
  requiredRowFragment: TicketRequiredRowFragmentDoc,
});
